var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"q-gutter-sm q-pa-lg"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 q-mb-md"},[_c('h4',{staticClass:"q-ma-none"},[_vm._v("Set Role Access")])]),_c('div',{staticClass:"col-12 q-mb-md"})])])
}]

export { render, staticRenderFns }